import { cx } from './cx';

export type StatusKind = 'pending' | 'processing' | 'complete' | 'failed' | 'info';

export interface StatusPillProps {
  status: StatusKind;
  children?: React.ReactNode;
  className?: string;
}

const STYLES: Record<StatusKind, string> = {
  pending: 'bg-warning/20 text-warning border-warning/50',
  processing: 'bg-info/20 text-info-soft border-info/50',
  complete: 'bg-success/20 text-success border-success/50',
  failed: 'bg-danger/20 text-danger-soft border-danger/50',
  info: 'bg-white/10 text-caption-muted border-border-ice',
};

const DEFAULT_LABELS: Record<StatusKind, string> = {
  pending: 'Pending',
  processing: 'Processing',
  complete: 'Complete',
  failed: 'Failed',
  info: 'Info',
};

/** Cosmos status pill (1e): PENDING / PROCESSING / COMPLETE / FAILED. */
export default function StatusPill({ status, children, className }: StatusPillProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full border',
        'font-ui text-[length:var(--text-label)] font-semibold uppercase tracking-[0.18em]',
        STYLES[status],
        className
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden />
      {children ?? DEFAULT_LABELS[status]}
    </span>
  );
}
